import colors from 'styles/colors';
import { SVGComponentPropsType } from './types';

const defaultWidth = 32;
const defaultHeight = 24;
const defaultBatteryLevel = 100;

type PropsType = SVGComponentPropsType & {
  isCharging?: boolean;
  batteryLevel?: number;
};

export default ({
  width = defaultWidth,
  height = defaultHeight,
  batteryLevel = defaultBatteryLevel,
  isCharging = false,
  ...props
}: PropsType) => {
  const fillHeight = Math.max(0, Math.min(22, (batteryLevel / 100) * 22)); // clamp between 0 and 22
  const fillY = 5 + (22 - fillHeight); // so fill grows from left to right

  const getFillColor = (level: number) => {
    if (level >= 80) {
      return colors.green;
    } else if (level >= 30) {
      return colors.yellow;
    }
    return colors.red;
  };

  const fillColor = getFillColor(batteryLevel);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox={`0 0 ${defaultWidth} ${defaultHeight}`}
      {...props}
    >
      <rect x="29" y="4" width="16" height="28" rx="3" transform="rotate(90 29 4)" stroke="#9599A2" strokeWidth="2" />
      <path d="M31 8a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-3V8z" fill="#9599A2" />
      {batteryLevel !== 0 && (
        <rect x="24" y={fillY} width="10" height={fillHeight} rx="1" transform="rotate(90 24 7)" fill={fillColor} />
      )}
      {isCharging && (
        <path
          d="M17.497 1.056 16.56 9.5h4.278l-.397.737-7 13-.937-.287.945-9.45H9.13l.438-.752 7-12z"
          fill={fillColor}
          stroke="#F2F2F2"
        />
      )}
    </svg>
  );
};
